<script>
import BillBackDetail from '@/views/bill/components/BillBackDetail.vue';
// eslint-disable-next-line no-unused-vars
import { API } from '@/net/http';
import BillStorageDetail from '@/views/bill/components/BillStorageDetail.vue';
import StripeBindCard from '@/components/stripe/StripeBindCard.vue';
import MkButton from '@/components/button/MkButton.vue';
import BillSendDetail from '@/views/bill/components/BillSendDetail.vue';
import BillAdjustmentDetail from '@/views/bill/components/BillAdjustmentDetail.vue';

export default {
  name: 'ChangeCardBill',
  // eslint-disable-next-line vue/no-unused-components
  components: { BillAdjustmentDetail, BillSendDetail, MkButton, StripeBindCard, BillStorageDetail, BillBackDetail },
  data() {
    return {
      orderNum: this.$route.params.orderNumber,
      bindLoading: false,
      apiLoading: false,
      totalFee: 0,
      failedSendBills: [],
      failedStorageBills: [],
      failedBackBills: [],
      failedAdjustment: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    bind() {},
    onBindSuccess() {
      this.$router.push('/send/' + this.orderNum);
    },
  },
};
</script>

<template>
  <i-row :gutter="60">
    <i-col span="12">
      <p class="title">Change your payment method</p>
      <div style="position: relative">
        <stripe-bind-card ref="stripeBindCard" @change-loading="bindLoading = $event" @bind-success="onBindSuccess" />
        <div style="margin: 30px; text-align: center;">
          <mk-button type="primary" @click="$refs.stripeBindCard.confirmPayment(false)">
            Change
          </mk-button>
        </div>
        <i-spin v-if="bindLoading || apiLoading" fix>
          <i-icon type="ios-loading" size="40" class="spin-icon-load" />
        </i-spin>
      </div>
    </i-col>
    <i-col span="11" :offset="1">
    </i-col>
  </i-row>
</template>

<style lang="less" scoped>
@import '~@/assets/fonts/font.less';

.title {
  .font-medium;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 30px;
}
.total-fee {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;

  .font-medium;
  font-size: 18px;
  font-weight: 400;
}
</style>
